import { Spinner } from "@/shared/spinner/spinner";

/**
 * Full-viewport Suspense fallback for route-level lazy loading (Vike shell, SPA catch-all, App routes).
 */
export default function RouteLoadingFallback() {
  return (
    <div
      className="fixed inset-0 z-[2147483000] flex flex-col items-center justify-center gap-4 bg-[#f5f5f3]"
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <Spinner isLoading size="large" classname="!block" />
    </div>
  );
}

/** Centered loader for lazy content inside modals / small surfaces (not full-screen). */
export function InlineLazyFallback() {
  return (
    <div
      className="flex min-h-[200px] w-full flex-col items-center justify-center gap-3 py-8"
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <Spinner isLoading size="medium" classname="!block" />
    </div>
  );
}
